<template>
  <Modal v-model="modal" title="修改密码" @on-cancel="init" footer-hide>
    <Form class="password" ref="formValidate" :model="formValidate" :rules="ruleValidate" v-if="modal">
      <FormItem prop="oldPassWord" label="当前登录密码">
        <Input v-model="formValidate.oldPassWord" type="password" placeholder="当前登录密码" password>
          <span slot="prefix" class="proxy-icon passWord-icon"></span>
        </Input>
      </FormItem>
      <FormItem prop="newPassWord" label="新登录密码">
        <Input v-model="formValidate.newPassWord" type="password" placeholder="新登录密码" password>
          <span slot="prefix" class="proxy-icon passWord-icon"></span>
        </Input>
      </FormItem>
      <FormItem prop="verifyPassWord" label="确认新登录密码">
        <Input v-model="formValidate.verifyPassWord" type="password" placeholder="确认新登录密码" password>
          <span slot="prefix" class="proxy-icon passWord-icon"></span>
        </Input>
      </FormItem>
      <FormItem class="fun-form">
        <a href="http://union.233.com/LM/findpwd">忘记密码?</a>
        <Button type="primary" :loading="loading" @click="handleSubmit('formValidate')">提交</Button>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import { isPassword } from "@/lib/verification/index"
export default {
  name: "EditPassword",
  data() {
    return {
      modal: false,
      loading: false,
      formValidate: {
        oldPassWord: '',
        newPassWord: '',
        verifyPassWord: ''
      },
      ruleValidate: {
        oldPassWord: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('当前密码不能为空'))
            } else if (isPassword(value)) {
              return callback(new Error('必须是6-20位英文字母、数字或符号组合，不能是纯字母、纯数字、纯符号'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        newPassWord: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('密码不能为空'))
            } else if (isPassword(value)) {
              return callback(new Error('必须是6-20位英文字母、数字或符号组合，不能是纯字母、纯数字、纯符号'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        verifyPassWord: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('确认新登录密码不能为空'))
            } else if (isPassword(value)) {
              return callback(new Error('必须是6-20位英文字母、数字或符号组合，不能是纯字母、纯数字、纯符号'))
            } else if (value !== this.formValidate.newPassWord) {
              return callback(new Error('新密码和确认密码输入不一致，请重新输入'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.ChangeUnionPwd()
        } else {
          // this.$Message.error('验证失败!')
        }
      })
    },
    ChangeUnionPwd() {
      this.loading = true
      this.$store.dispatch('account/ChangeUnionPwd', this.formValidate).then(({ msg, list }) => {
        this.loading = false
        this.modal = false
        this.$store.commit("loginReg/updataToken", list)
        this.init()
        this.$Message.success(msg)
      }).catch(({ msg })  => {
        this.loading = false
        this.$Message.error(msg)
      })
    },
    init() {
      this.formValidate = {
        oldPassWord: '',
        newPassWord: '',
        verifyPassWord: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.password{
  .fun-form /deep/.ivu-form-item-content{
    line-height: 1;
    text-align: right;
    a{
      display: inline-block;
      margin-bottom: 10px;
      color: #e13b29;
    }
  }
}
</style>